const r = "_text_or66x_1", t = "_inputWrapper_or66x_4", p = "_input_or66x_4", e = "_errorWrapper_or66x_10", o = {
  text: r,
  inputWrapper: t,
  input: p,
  errorWrapper: e
};
export {
  o as default,
  e as errorWrapper,
  p as input,
  t as inputWrapper,
  r as text
};
